import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Linkify from 'react-linkify';
import { removeSignature } from 'utils/functions';

const linkifyProps = { target: '_blank' };

const ChatMessage = ({ message, sender, timestamp, className }) => {
  const time = timestamp && moment(timestamp).format('HH:mm');
  const isFromAgent = sender && (sender.agent || sender.name === 'Ontruck');
  const messageFormatted = !!message && removeSignature(message);

  return (
    <div className={className} data-testid="chat-message">
      <div
        data-testid="chat-message__block"
        className={`chat-message ${
          isFromAgent ? 'chat-message--agent' : 'chat-message--user'
        }`}
      >
        <div className="chat-message__container">
          <div className={`chat-message__content `}>
            <Linkify properties={linkifyProps}>{messageFormatted}</Linkify>
          </div>
          <div className="chat-message__time">{`${time} ${
            isFromAgent ? ` - ${sender.name}` : ''
          }`}</div>
        </div>
      </div>
    </div>
  );
};

ChatMessage.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string.isRequired,
  sender: PropTypes.object,
  timestamp: PropTypes.string.isRequired,
};

export default ChatMessage;
